export enum SharedViewLogoType {
    GOODDAY = 'goodday',
    COMPANY = 'company',
    NONE    = 'none',
}